import { jsx } from "react/jsx-runtime";
import { TextInputFieldWUT } from "../../../ui/text-input-field/text-input-field-wut.js";
import { FIELD_TYPES } from "../../../constants/field-types.js";
const ContactsCompanyWUT = (props) => {
  const fieldType = FIELD_TYPES.CONTACTS_COMPANY;
  return /* @__PURE__ */ jsx(TextInputFieldWUT, { ...props, fieldType });
};
export {
  ContactsCompanyWUT
};
//# sourceMappingURL=contacts-company-wut.js.map
